// Excel експортът на „По артикули".
//
// Таблицата е страницирана от сървъра, затова файлът НЕ е срез на видимото:
// периодът се дърпа наново по активните филтри (`fetchAllOrderedItems`) и
// излиза целият. Числата остават ЧИСЛА — „5,95 €" в клетка убива всяко SUM.

import {
  type OrderedItem,
  type OrderedItemsFilters,
} from "../../../../api/reports";
import { parseDecimal } from "../../../../components/dataTable";
import { exportToExcel } from "../../../../utils/excelExport";
import { fetchAllOrderedItems } from "./orderedItemsFetch";

type ExportContext = {
  t: (key: string) => string;
  /** Асортимент / Рецепта / Добавка — терминологията зависи от режима. */
  kindLabelOf: (row: OrderedItem) => string;
  /** Името на справката: „По артикули" или „По рецепти". */
  reportName: string;
};

export const exportItems = async (
  filters: OrderedItemsFilters,
  { t, kindLabelOf, reportName }: ExportContext,
): Promise<void> => {
  const { items, grandTotal } = await fetchAllOrderedItems(filters);

  exportToExcel<OrderedItem>({
    // БЕЗ собствен времеви печат — `exportToExcel` вече лепи `_${stamp}`.
    filename: reportName,
    sheetName: reportName,
    columns: [
      {
        header: t("reportsPage.productName"),
        value: (row) =>
          row.is_lunch
            ? `${row.name} (${t("reportsPage.lunchTag")})`
            : row.name,
        width: 30,
      },
      {
        header: t("reportsPage.assortmentColKind"),
        value: (row) => kindLabelOf(row),
        width: 14,
      },
      {
        header: t("reportsPage.category"),
        value: (row) => row.category_name ?? "",
        width: 20,
      },
      {
        header: t("reportsPage.station"),
        value: (row) => row.station_name,
        width: 20,
      },
      {
        header: t("reportsPage.itemsColCount"),
        value: (row) => parseDecimal(row.count),
        width: 12,
      },
      {
        header: t("reportsPage.itemsColPrice"),
        value: (row) => parseDecimal(row.avg_price),
        width: 14,
      },
      {
        header: t("reportsPage.itemsColRevenue"),
        value: (row) => parseDecimal(row.total_sum),
        width: 14,
      },
      {
        header: t("reportsPage.itemsColShare"),
        value: (row) =>
          grandTotal > 0
            ? Number(
                ((parseDecimal(row.total_sum) / grandTotal) * 100).toFixed(2),
              )
            : 0,
        width: 12,
      },
    ],
    rows: items,
  });
};
